module.exports = __webpack_public_path__ + "img/aside-left-hand.ec83703e.png";